import React, { useState, useEffect } from 'react';
import api from '../api/client';
import UsageTab from './UsageTab';

const S = {
  wrap: { maxWidth: 960, margin: '0 auto', fontFamily: 'inherit' },
  header: { background: '#3c3489', color: '#fff', padding: '12px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  body: { background: '#f0f2f5', minHeight: '100vh', padding: 16 },
  nav: { display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' },
  navBtn: { padding: '8px 16px', border: '1px solid #d0d8e8', borderRadius: 8, background: '#fff', color: '#666', fontSize: 13, cursor: 'pointer' },
  navBtnActive: { padding: '8px 16px', border: '1px solid #3c3489', borderRadius: 8, background: '#3c3489', color: '#fff', fontSize: 13, cursor: 'pointer' },
  card: { background: '#fff', border: '1px solid #d0d8e8', borderRadius: 12, padding: 20, marginBottom: 16 },
  cardTitle: { fontSize: 15, fontWeight: 600, color: '#333', marginBottom: 16 },
  sectionTitle: { fontSize: 13, fontWeight: 600, color: '#3c3489', marginBottom: 10, paddingBottom: 6, borderBottom: '2px solid #eeedfe' },
  label: { fontSize: 13, color: '#666', marginBottom: 6, display: 'block' },
  input: { width: '100%', padding: '9px 12px', border: '1px solid #d0d8e8', borderRadius: 8, fontSize: 14, marginBottom: 12, outline: 'none', boxSizing: 'border-box' },
  inputSm: { padding: '6px 10px', border: '1px solid #d0d8e8', borderRadius: 6, fontSize: 13, outline: 'none', width: 160 },
  select: { width: '100%', padding: '9px 12px', border: '1px solid #d0d8e8', borderRadius: 8, fontSize: 14, marginBottom: 12, background: '#fff' },
  pasteArea: { width: '100%', minHeight: 180, padding: '10px 12px', border: '2px dashed #afa9ec', borderRadius: 8, fontSize: 13, marginBottom: 8, resize: 'vertical', boxSizing: 'border-box', fontFamily: 'monospace', background: '#fafafa', outline: 'none' },
  hint: { fontSize: 12, color: '#888', marginBottom: 12, lineHeight: 1.8, background: '#f5f7fb', padding: '10px 12px', borderRadius: 8 },
  btn: { padding: '7px 14px', border: '1px solid #d0d8e8', borderRadius: 8, background: '#fff', color: '#666', fontSize: 12, cursor: 'pointer' },
  btnPrimary: { padding: '9px 20px', border: 'none', borderRadius: 8, background: '#3c3489', color: '#fff', fontSize: 13, fontWeight: 500, cursor: 'pointer' },
  btnDanger: { padding: '7px 14px', border: '1px solid #e24b4a', borderRadius: 8, background: '#fff', color: '#e24b4a', fontSize: 12, cursor: 'pointer' },
  btnSuccess: { padding: '7px 14px', border: 'none', borderRadius: 8, background: '#1d9e75', color: '#fff', fontSize: 12, cursor: 'pointer' },
  logoutBtn: { fontSize: 12, padding: '5px 12px', border: '1px solid rgba(255,255,255,0.5)', borderRadius: 6, cursor: 'pointer', background: 'transparent', color: '#fff' },
  successMsg: { background: '#e1f5ee', color: '#085041', borderRadius: 8, padding: '12px 16px', fontSize: 14, marginBottom: 16 },
  errorMsg: { background: '#fff5f5', color: '#e24b4a', borderRadius: 8, padding: '12px 16px', fontSize: 14, marginBottom: 16 },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' },
  infoBox: { background: '#f5f7fb', borderRadius: 8, padding: 16, marginBottom: 16 },
  infoRow: { display: 'flex', padding: '7px 0', borderBottom: '1px solid #eee', fontSize: 13 },
  infoLabel: { width: 140, color: '#888', flexShrink: 0 },
  previewWrap: { marginBottom: 16 },
  previewTitle: { fontSize: 12, color: '#888', marginBottom: 6 },
  previewTable: { width: '100%', borderCollapse: 'collapse', fontSize: 12 },
  previewTh: { padding: '6px 10px', background: '#f0eefe', textAlign: 'left', borderBottom: '1px solid #d0d8e8', color: '#3c3489', fontWeight: 600 },
  previewTd: { padding: '5px 10px', borderBottom: '1px solid #f5f5f5' },
  stepBadge: { display: 'inline-flex', width: 22, height: 22, borderRadius: '50%', background: '#3c3489', color: '#fff', fontSize: 12, fontWeight: 600, alignItems: 'center', justifyContent: 'center', marginRight: 8, flexShrink: 0 },
  stepRow: { display: 'flex', alignItems: 'flex-start', marginBottom: 20 },
  pwTag: { display: 'inline-block', fontSize: 11, background: '#f0eefe', color: '#3c3489', padding: '2px 8px', borderRadius: 4, fontFamily: 'monospace', margin: '2px' },
  warningBox: { background: '#fff8e1', border: '1px solid #ffd54f', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#7a5800', marginBottom: 12 },
  schoolRow: { display: 'flex', alignItems: 'center', gap: 10, padding: '12px 0', borderBottom: '1px solid #f0f2f5', flexWrap: 'wrap' },
  badgeActive: { padding: '3px 10px', borderRadius: 99, fontSize: 11, background: '#e1f5ee', color: '#085041', whiteSpace: 'nowrap' },
  badgeExpired: { padding: '3px 10px', borderRadius: 99, fontSize: 11, background: '#fcebeb', color: '#791f1f', whiteSpace: 'nowrap' },
  badgeInactive: { padding: '3px 10px', borderRadius: 99, fontSize: 11, background: '#f0f2f5', color: '#666', whiteSpace: 'nowrap' },
  schoolCode: { fontSize: 13, fontWeight: 700, color: '#3c3489', minWidth: 80 },
  detailCard: { background: '#f5f7fb', borderRadius: 8, padding: 16, marginTop: 12 },
  pwEditRow: { display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 },
};

function parsePaste(text) {
  return text.trim().split('\n')
    .map(line => line.trim().split(/\t+|\s{2,}/))
    .filter(cols => cols.length >= 4)
    .map(cols => ({
      grade:      parseInt(cols[0]),
      class_name: String(cols[1]).trim().replace(/^(\d+)$/, '$1組'),
      number:     parseInt(cols[2]),
      password:   String(cols[3]).trim()
    }))
    .filter(r => !isNaN(r.grade) && r.class_name && !isNaN(r.number) && r.password);
}

function groupByClass(students) {
  return students.reduce((acc, s) => {
    const key = `${s.grade}年${s.class_name}`;
    if (!acc[key]) acc[key] = [];
    acc[key].push(s);
    return acc;
  }, {});
}

function getStatus(school) {
  if (school.status === 'inactive') return 'inactive';
  const today = new Date();
  const end = new Date(school.contract_end);
  return end < today ? 'expired' : 'active';
}

export default function AdminPage() {
  const [section, setSection] = useState('register');
  const [credForm, setCredForm] = useState({ login_id: '', current_password: '', new_password: '', new_password2: '' });
  const [credMsg, setCredMsg] = useState('');
  const [credError, setCredError] = useState('');
  const updateCredentials = async () => {
    setCredMsg(''); setCredError('');
    if (credForm.new_password && credForm.new_password !== credForm.new_password2) {
      setCredError('新しいパスワードが一致しません'); return;
    }
    try {
      await api.patch('/admin/me/credentials', {
        login_id: credForm.login_id || undefined,
        current_password: credForm.current_password,
        new_password: credForm.new_password || undefined
      });
      setCredMsg('変更しました');
      setCredForm({ login_id: '', current_password: '', new_password: '', new_password2: '' });
    } catch(e) { setCredError(e.response?.data?.error || '変更に失敗しました'); }
  };
  const [form, setForm] = useState({ name: '', schoolCode: '', type: 'elementary', start: '', end: '', teacherLoginId: '', teacherPassword: '' });
  const [pasteText, setPasteText] = useState('');
  const [parsed, setParsed] = useState([]);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [registeredInfo, setRegisteredInfo] = useState(null);
  const [schools, setSchools] = useState([]);
  const [expandedSchool, setExpandedSchool] = useState(null);
  const [schoolTeachers, setSchoolTeachers] = useState([]);
  const [schoolClasses, setSchoolClasses] = useState([]);
  const [newContractEnd, setNewContractEnd] = useState('');
  const [addingClass, setAddingClass] = useState(false);
  const [newClassForm, setNewClassForm] = useState({ grade: '', class_name: '', student_count: 30, pwMode: 'auto', pasteText: '' });
  const [addClassResult, setAddClassResult] = useState(null);
  const [editingPw, setEditingPw] = useState({});
  const [newPw, setNewPw] = useState({});

  useEffect(() => { if (section === 'schools') fetchSchools(); }, [section]);

  const logout = () => { localStorage.clear(); window.location.href = '/login'; };
  const showSuccess = (msg) => { setSuccessMsg(msg); setTimeout(() => setSuccessMsg(''), 5000); };
  const showError   = (msg) => { setErrorMsg(msg);   setTimeout(() => setErrorMsg(''), 5000); };

  const fetchSchools = async () => {
    try { const r = await api.get('/admin/schools'); setSchools(r.data); } catch(e) { showError('学校一覧の取得に失敗しました'); }
  };

  // 貼り付けた「番号 パスワード」（学校登録と同じ4列「学年 組 番号 パスワード」でも可）を読む
  const parseClassPaste = (text) => text.split('\n').map(l => l.trim()).filter(Boolean).map(l => {
    const c = l.split(/[\t,，\s]+/);
    return c.length >= 4 ? { number: parseInt(c[2]), password: c[3] } : { number: parseInt(c[0]), password: c[1] };
  });
  // 組の表示（サーバーと同じく「数字＋組」にそろえる）
  const classLabel = (v) => { const n = String(v || '').trim().replace(/[０-９]/g, c => String.fromCharCode(c.charCodeAt(0) - 0xFEE0)).replace(/組$/, ''); return /^\d{1,2}$/.test(n) ? `${parseInt(n)}組` : ''; };

  // ★クラスの追加は料金に関わるため管理者だけ（2026-09-19 作り直し）。
  //   既にあるクラスには触れない専用の窓口を使う（以前の /admin/students/bulk はパスワードを上書きしていた）
  const handleAddClass = async (school) => {
    if (!newClassForm.grade || !classLabel(newClassForm.class_name)) { showError('学年と組（数字）を入力してください'); return; }
    const body = { grade: parseInt(newClassForm.grade), class_name: newClassForm.class_name };
    if (newClassForm.pwMode === 'paste') {
      body.students = parseClassPaste(newClassForm.pasteText);
      if (!body.students.length) { showError('児童の番号とパスワードを貼り付けてください'); return; }
    } else {
      body.student_count = parseInt(newClassForm.student_count);
    }
    const n = body.students ? body.students.length : body.student_count;
    if (!window.confirm(`${newClassForm.grade}年${classLabel(newClassForm.class_name)} を ${n}人で追加します。\nクラスの追加は料金に関わります。よろしいですか？`)) return;
    setLoading(true);
    try {
      const r = await api.post(`/admin/schools/${school.id}/classes`, body);
      setAddClassResult(r.data);
      showSuccess(`${r.data.class.grade}年${r.data.class.class_name}を追加しました（${r.data.created_count}名）`);
      setNewClassForm({ grade: '', class_name: '', student_count: 30, pwMode: 'auto', pasteText: '' });
      // ★expandSchool は「開いていたら閉じる」切り替えなので呼ばない（呼ぶと結果と印刷ボタンが消える）。
      //   欄は開いたまま、クラス一覧と学校一覧（児童数）だけ読み直す
      api.get(`/admin/schools/${school.id}/classes`).then(c => setSchoolClasses(c.data)).catch(() => {});
      fetchSchools();
    } catch(e) { showError(e.response?.data?.error || 'クラス追加に失敗しました'); }
    finally { setLoading(false); }
  };

  const printClassAccounts = (result) => {
    const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const title = `${result.class.grade}年${result.class.class_name}`;
    const rows = result.accounts.map(a => `<tr><td>${esc(title)}</td><td>${a.number}番</td><td style="font-family:monospace;font-size:18px">${esc(a.password)}</td></tr>`).join('');
    const w = window.open('', '_blank');
    w.document.write(`<html><head><title>${esc(title)} パスワード一覧</title><style>body{font-family:sans-serif;padding:20px}table{border-collapse:collapse}td,th{border:1px solid #999;padding:6px 14px}@media print{button{display:none}}</style></head><body><h2>${esc(title)} パスワード一覧</h2><table><tr><th>クラス</th><th>番号</th><th>パスワード</th></tr>${rows}</table><p><button onclick="window.print()">印刷</button></p></body></html>`);
    w.document.close();
  };

  const expandSchool = async (school) => {
    if (expandedSchool?.id === school.id) { setExpandedSchool(null); return; }
    setExpandedSchool(school);
    setNewContractEnd(school.contract_end?.split('T')[0] || '');
    try {
      const [t, c] = await Promise.all([
        api.get(`/admin/schools/${school.id}/teachers`),
        api.get(`/admin/schools/${school.id}/classes`)
      ]);
      setSchoolTeachers(t.data);
      setSchoolClasses(c.data);
    } catch(e) { showError('詳細の取得に失敗しました'); }
  };

  const updateContract = async (schoolId) => {
    try {
      await api.patch(`/admin/schools/${schoolId}/contract`, { contract_end: newContractEnd, status: 'active' });
      showSuccess('契約期間を更新しました');
      fetchSchools();
    } catch(e) { showError('更新に失敗しました'); }
  };

  const deleteSchool = async (school) => {
    if (!window.confirm(`「${school.school_name}」を完全に削除しますか？この操作は取り消せません。`)) return;
    try {
      await api.delete(`/admin/schools/${school.id}`);
      showSuccess('学校を削除しました');
      setExpandedSchool(null);
      fetchSchools();
    } catch(e) { showError('削除に失敗しました'); }
  };

  const updateTeacherLoginId = async (teacherId) => {
    const newId = newPw[`t-id-${teacherId}`];
    if (!newId || newId.length < 3) { alert('3文字以上のIDを入力してください'); return; }
    try {
      await api.patch(`/admin/teachers/${teacherId}/login_id`, { login_id: newId });
      setEditingPw(p => ({ ...p, [`t-id-${teacherId}`]: false }));
      setNewPw(p => ({ ...p, [`t-id-${teacherId}`]: '' }));
      expandSchool(expandedSchool);
      alert('ログインIDを変更しました');
    } catch(e) { alert(e.response?.data?.error || 'ID変更に失敗しました'); }
  };

  const updateTeacherPw = async (teacherId) => {
    const pw = newPw[`t-${teacherId}`];
    if (!pw || pw.length < 4) { showError('4文字以上のパスワードを入力してください'); return; }
    try {
      await api.patch(`/admin/teachers/${teacherId}/password`, { password: pw });
      setEditingPw(prev => ({ ...prev, [`t-${teacherId}`]: false }));
      setNewPw(prev => ({ ...prev, [`t-${teacherId}`]: '' }));
      showSuccess('教師のパスワードを変更しました');
    } catch(e) { showError('変更に失敗しました'); }
  };

  const updateStudentPw = async (studentId) => {
    const pw = newPw[`s-${studentId}`];
    if (!pw || pw.length < 4) { showError('4文字以上のパスワードを入力してください'); return; }
    try {
      await api.patch(`/admin/students/${studentId}/password`, { password: pw });
      setEditingPw(prev => ({ ...prev, [`s-${studentId}`]: false }));
      setNewPw(prev => ({ ...prev, [`s-${studentId}`]: '' }));
      showSuccess('児童のパスワードを変更しました');
    } catch(e) { showError('変更に失敗しました'); }
  };

  const handlePaste = (text) => { setPasteText(text); setParsed(parsePaste(text)); };

  const handleRegister = async () => {
    if (!form.schoolCode) { showError('学校コードを入力してください'); return; }
    if (!form.name || !form.start || !form.end) { showError('学校名・契約期間を入力してください'); return; }
    if (!form.teacherLoginId || !form.teacherPassword) { showError('教師のログインIDとパスワードを入力してください'); return; }
    if (parsed.length === 0) { showError('児童データを貼り付けてください'); return; }
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch('/api/admin/schools/full', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ school_code: form.schoolCode.toUpperCase(), school_name: form.name, school_type: form.type, contract_start: form.start, contract_end: form.end, teacher_login_id: form.teacherLoginId, teacher_password: form.teacherPassword, students: parsed })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || '登録に失敗しました');
      setRegisteredInfo(data);
      showSuccess(`「${form.name}」を登録しました！学校コード：${data.school.school_code}`);
      setForm({ name: '', schoolCode: '', type: 'elementary', start: '', end: '', teacherLoginId: '', teacherPassword: '' });
      setPasteText(''); setParsed([]);
      setSection('schools');
    } catch (e) { showError(e.message); }
    finally { setLoading(false); }
  };

  const grouped = groupByClass(parsed);
  const classSummary = Object.entries(grouped).map(([k, v]) => `${k}（${v.length}名）`).join('、');

  const statusBadge = (school) => {
    const s = getStatus(school);
    if (s === 'expired') return <span style={S.badgeExpired}>期限切れ</span>;
    if (s === 'inactive') return <span style={S.badgeInactive}>停止中</span>;
    return <span style={S.badgeActive}>契約中</span>;
  };

  return (
    <div style={S.wrap}>
      <div style={S.header}>
        <div style={{ fontSize: 15, fontWeight: 600 }}>ふりカエル 管理者ダッシュボード</div>
        <div style={{ fontSize: 12, opacity: 0.8 }}>本吉研究室</div>
        <button style={S.logoutBtn} onClick={logout}>ログアウト</button>
      </div>
      <div style={S.body}>
        <div style={S.nav}>
          {[['register','新規学校登録'],['schools','学校管理'],['usage','利用状況'],['account','アカウント設定']].map(([k,v]) => (
            <button key={k} style={section===k ? S.navBtnActive : S.navBtn} onClick={() => setSection(k)}>{v}</button>
          ))}
        </div>

        {successMsg && <div style={S.successMsg}>{successMsg}</div>}
        {errorMsg   && <div style={S.errorMsg}>{errorMsg}</div>}

        {section === 'usage' && <UsageTab />}

        {section === 'register' && (
          <div style={S.card}>
            <div style={S.cardTitle}>新規学校登録</div>
            <div style={S.stepRow}>
              <span style={S.stepBadge}>1</span>
              <div style={{ flex: 1 }}>
                <div style={S.sectionTitle}>学校情報</div>
                <div style={S.grid2}>
                  <div><label style={S.label}>学校コード <span style={{color:"#e53e3e"}}>※必須</span></label><input style={S.input} placeholder="例：WAKU01" value={form.schoolCode} onChange={e => setForm({ ...form, schoolCode: e.target.value.toUpperCase() })} /><div style={{fontSize:11,color:"#888",marginTop:2}}>※英数字で学校を識別するコードです。児童のログイン時に使用します。</div></div>
                  <div><label style={S.label}>学校名</label><input style={S.input} placeholder="○○市立△△小学校" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /></div>
                  <div><label style={S.label}>学校種別</label><select style={S.select} value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}><option value="elementary">小学校</option><option value="junior">中学校</option><option value="special">特別支援学校</option></select></div>
                  <div><label style={S.label}>契約開始日</label><input style={S.input} type="date" value={form.start} onChange={e => setForm({ ...form, start: e.target.value })} /></div>
                  <div><label style={S.label}>契約終了日</label><input style={S.input} type="date" value={form.end} onChange={e => setForm({ ...form, end: e.target.value })} /></div>
                </div>
              </div>
            </div>
            <div style={S.stepRow}>
              <span style={S.stepBadge}>2</span>
              <div style={{ flex: 1 }}>
                <div style={S.sectionTitle}>教師アカウント</div>
                <div style={S.grid2}>
                  <div><label style={S.label}>ログインID</label><input style={S.input} placeholder="例：teacher-abc01" value={form.teacherLoginId} onChange={e => setForm({ ...form, teacherLoginId: e.target.value })} /></div>
                  <div><label style={S.label}>パスワード</label><input style={S.input} placeholder="例：pass1234" value={form.teacherPassword} onChange={e => setForm({ ...form, teacherPassword: e.target.value })} /></div>
                </div>
              </div>
            </div>
            <div style={S.stepRow}>
              <span style={S.stepBadge}>3</span>
              <div style={{ flex: 1 }}>
                <div style={S.sectionTitle}>児童・生徒データ（スプレッドシートからコピペ）</div>
                <div style={S.hint}>形式：<strong>学年 [TAB] 組 [TAB] 番号 [TAB] パスワード</strong>　※組は数字のみ（例：1）でも「1組」でも可</div>
                <textarea style={S.pasteArea} placeholder={'3\t1\t1\tsakura2026\n3\t1\t2\thana1234'} value={pasteText} onChange={e => handlePaste(e.target.value)} />
                {parsed.length > 0 && (
                  <div style={S.previewWrap}>
                    <div style={S.previewTitle}>{classSummary}　合計 {parsed.length} 名</div>
                    <table style={S.previewTable}>
                      <thead><tr><th style={S.previewTh}>学年</th><th style={S.previewTh}>組</th><th style={S.previewTh}>番号</th><th style={S.previewTh}>パスワード</th></tr></thead>
                      <tbody>
                        {parsed.slice(0, 8).map((r, i) => (
                          <tr key={i}><td style={S.previewTd}>{r.grade}年</td><td style={S.previewTd}>{r.class_name}</td><td style={S.previewTd}>{r.number}番</td><td style={S.previewTd}><span style={S.pwTag}>{r.password}</span></td></tr>
                        ))}
                        {parsed.length > 8 && <tr><td colSpan={4} style={{ ...S.previewTd, color: '#aaa', textAlign: 'center' }}>他 {parsed.length - 8} 名...</td></tr>}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
            {parsed.length > 0 && form.name && form.teacherLoginId && (
              <div style={S.warningBox}>登録内容：<strong>{form.name}</strong>　教師ID：<strong>{form.teacherLoginId}</strong>　児童 <strong>{parsed.length}名</strong>（{classSummary}）</div>
            )}
            <button style={{ ...S.btnPrimary, opacity: loading ? 0.7 : 1 }} onClick={handleRegister} disabled={loading}>
              {loading ? '登録中...' : '学校を登録してアカウントを発行する'}
            </button>
          </div>
        )}

        {section === 'schools' && (
          <div style={S.card}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <div style={S.cardTitle}>登録学校一覧</div>
              <button style={S.btn} onClick={fetchSchools}>更新</button>
            </div>
            {schools.map(school => (
              <div key={school.id}>
                <div style={S.schoolRow}>
                  <span style={S.schoolCode}>{school.school_code}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 14, fontWeight: 500 }}>{school.school_name}</div>
                    <div style={{ fontSize: 12, color: '#aaa' }}>
                      {school.contract_start?.split('T')[0]} 〜 {school.contract_end?.split('T')[0]}　
                      教師{school.teacher_count}名 / 児童{school.student_count}名
                    </div>
                  </div>
                  {statusBadge(school)}
                  <button style={S.btn} onClick={() => expandSchool(school)}>
                    {expandedSchool?.id === school.id ? '閉じる' : '管理'}
                  </button>
                </div>

                {expandedSchool?.id === school.id && (
                  <div style={S.detailCard}>
                    <div style={{ background: '#f0effe', borderRadius: 8, padding: '10px 16px', marginBottom: 16, display: 'flex', gap: 24, flexWrap: 'wrap', alignItems: 'center' }}>
                      <div>
                        <span style={{ fontSize: 11, color: '#888' }}>学校コード（児童ログイン用）</span>
                        <div style={{ fontSize: 20, fontWeight: 700, color: '#3c3489', letterSpacing: 3 }}>{school.school_code}</div>
                      </div>
                      <div>
                        <span style={{ fontSize: 11, color: '#888' }}>教師ログインID</span>
                        <div style={{ fontSize: 15, fontWeight: 600, color: '#333' }}>{schoolTeachers[0]?.login_id || '-'}</div>
                      </div>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#3c3489' }}>契約期間の更新</div>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                          <input type="date" style={S.inputSm} value={newContractEnd} onChange={e => setNewContractEnd(e.target.value)} />
                          <button style={S.btnSuccess} onClick={() => updateContract(school.id)}>更新</button>
                        </div>
                      </div>
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#e24b4a' }}>学校の削除</div>
                        <button style={S.btnDanger} onClick={() => deleteSchool(school)}>この学校を完全に削除する</button>
                        <div style={{ fontSize: 11, color: '#aaa', marginTop: 4 }}>※全データが削除されます</div>
                      </div>
                    </div>

                    {schoolTeachers.length > 0 && (
                      <div style={{ marginTop: 16 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#3c3489' }}>教師アカウント</div>
                        {schoolTeachers.map(t => (
                          <div key={t.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', borderBottom: '1px solid #eee', flexWrap: 'wrap' }}>
                            {editingPw[`t-id-${t.id}`] ? (
                              <div style={S.pwEditRow}>
                                <input style={S.inputSm} type="text" placeholder="新しいID" value={newPw[`t-id-${t.id}`] || ''} onChange={e => setNewPw(p => ({ ...p, [`t-id-${t.id}`]: e.target.value }))} />
                                <button style={S.btnPrimary} onClick={() => updateTeacherLoginId(t.id)}>保存</button>
                                <button style={S.btn} onClick={() => setEditingPw(p => ({ ...p, [`t-id-${t.id}`]: false }))}>取消</button>
                              </div>
                            ) : (
                              <span style={{ fontSize: 13, fontWeight: 500, minWidth: 120 }}>{t.login_id}</span>
                            )}
                            {editingPw[`t-${t.id}`] ? (
                              <div style={S.pwEditRow}>
                                <input style={S.inputSm} type="text" placeholder="新しいPW" value={newPw[`t-${t.id}`] || ''} onChange={e => setNewPw(p => ({ ...p, [`t-${t.id}`]: e.target.value }))} />
                                <button style={S.btnPrimary} onClick={() => updateTeacherPw(t.id)}>保存</button>
                                <button style={S.btn} onClick={() => setEditingPw(p => ({ ...p, [`t-${t.id}`]: false }))}>取消</button>
                              </div>
                            ) : (
                              <div style={{ display: 'flex', gap: 4 }}>
                                <button style={S.btn} onClick={() => setEditingPw(p => ({ ...p, [`t-id-${t.id}`]: true }))}>ID変更</button>
                                <button style={S.btn} onClick={() => setEditingPw(p => ({ ...p, [`t-${t.id}`]: true }))}>PW変更</button>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}

                    <div style={{ marginTop: 16 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: '#3c3489' }}>クラス管理</div>
                        <button style={S.btnPrimary} onClick={() => { setAddingClass(!addingClass); setAddClassResult(null); }}>
                          {addingClass ? '閉じる' : '＋ クラスを追加'}
                        </button>
                      </div>
                      {addingClass && (
                        <div style={{ background: '#f0effe', borderRadius: 8, padding: 16, marginBottom: 12 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: '#3c3489', marginBottom: 12 }}>新しいクラスを追加</div>
                          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'flex-end' }}>
                            <div>
                              <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>学年</div>
                              <select style={S.inputSm} value={newClassForm.grade} onChange={e => setNewClassForm(f => ({ ...f, grade: e.target.value }))}>
                                <option value="">選択</option>
                                {[1,2,3,4,5,6].map(g => <option key={g} value={g}>{g}年</option>)}
                              </select>
                            </div>
                            <div>
                              <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>組（数字）</div>
                              <input style={{ ...S.inputSm, width: 60 }} placeholder="例：2" value={newClassForm.class_name} onChange={e => setNewClassForm(f => ({ ...f, class_name: e.target.value }))} />
                            </div>
                            <div>
                              <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>パスワード</div>
                              <select style={S.inputSm} value={newClassForm.pwMode} onChange={e => setNewClassForm(f => ({ ...f, pwMode: e.target.value }))}>
                                <option value="auto">4けたの数字を自動で作る</option>
                                <option value="paste">学校が用意したものを貼り付ける</option>
                              </select>
                            </div>
                            {newClassForm.pwMode === 'auto' && (
                              <div>
                                <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>児童数</div>
                                <input style={{ ...S.inputSm, width: 70 }} type="number" min="1" max="60" value={newClassForm.student_count} onChange={e => setNewClassForm(f => ({ ...f, student_count: e.target.value }))} />
                              </div>
                            )}
                          </div>
                          {newClassForm.pwMode === 'paste' && (
                            <div style={{ marginTop: 10 }}>
                              <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>1行に「番号　パスワード」（Excel からそのまま貼り付けできます。学校登録と同じ「学年　組　番号　パスワード」でも可）</div>
                              <textarea style={{ ...S.pasteArea, minHeight: 120 }} placeholder={'1\tab12\n2\tcd34\n3\tef56'} value={newClassForm.pasteText} onChange={e => setNewClassForm(f => ({ ...f, pasteText: e.target.value }))} />
                            </div>
                          )}
                          <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 10, flexWrap: 'wrap' }}>
                            <button style={S.btnSuccess} onClick={() => handleAddClass(school)} disabled={loading}>
                              {loading ? '登録中...' : '追加する'}
                            </button>
                            <span style={{ fontSize: 12, color: '#666' }}>
                              {newClassForm.grade && classLabel(newClassForm.class_name)
                                ? `${newClassForm.grade}年${classLabel(newClassForm.class_name)} を ${newClassForm.pwMode === 'paste' ? parseClassPaste(newClassForm.pasteText).length : newClassForm.student_count}人で追加します`
                                : '学年と組を入れてください'}
                            </span>
                          </div>
                          <div style={{ fontSize: 11, color: '#888', marginTop: 8, lineHeight: 1.7 }}>
                            ※ クラスの追加は料金に関わるため、管理者だけが行えます。<br />
                            ※ すでにあるクラスを指定した場合は追加せずに止まります（そのクラスの児童には何も変更しません）。
                          </div>
                          {addClassResult && (
                            <div style={{ marginTop: 12, background: '#fff', borderRadius: 6, padding: 10 }}>
                              <div style={{ fontSize: 12, fontWeight: 600, color: '#059669', marginBottom: 8 }}>✓ {addClassResult.class.grade}年{addClassResult.class.class_name} を追加しました（{addClassResult.created_count}名）。パスワード一覧を印刷して先生にお渡しください（あとからでも下の「パスワード一覧を印刷」で印刷できます）。</div>
                              <button style={{ ...S.btn, fontSize: 11 }} onClick={() => printClassAccounts(addClassResult)}>パスワード一覧を印刷</button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {schoolClasses.length > 0 && (
                      <div style={{ marginTop: 16 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: '#3c3489' }}>児童パスワード変更</div>
                        {schoolClasses.map(cls => (
                          <div key={cls.id} style={{ marginBottom: 12 }}>
                            <div style={{ fontSize: 12, fontWeight: 600, color: '#666', marginBottom: 6 }}>{cls.grade}年{cls.class_name}</div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                              {cls.students.map(s => (
                                <div key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                  {editingPw[`s-${s.id}`] ? (
                                    <div style={S.pwEditRow}>
                                      <span style={{ fontSize: 12, color: '#888' }}>{s.number}番</span>
                                      <input style={{ ...S.inputSm, width: 100 }} type="text" placeholder="新PW" value={newPw[`s-${s.id}`] || ''} onChange={e => setNewPw(p => ({ ...p, [`s-${s.id}`]: e.target.value }))} />
                                      <button style={{ ...S.btnPrimary, padding: '4px 8px', fontSize: 11 }} onClick={() => updateStudentPw(s.id)}>保存</button>
                                      <button style={{ ...S.btn, padding: '4px 8px', fontSize: 11 }} onClick={() => setEditingPw(p => ({ ...p, [`s-${s.id}`]: false }))}>取消</button>
                                    </div>
                                  ) : (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 4, border: '1px solid #e2e8f0', borderRadius: 6, padding: '3px 8px', background: '#f8fafc' }}>
                                      <span style={{ fontSize: 12, color: '#444', minWidth: 30 }}>{s.number}番</span>
                                      <span style={{ fontSize: 12, color: '#2d4a8a', fontWeight: 600, minWidth: 60 }}>{s.password_plain || '****'}</span>
                                      <button style={{ ...S.btn, fontSize: 10, padding: '2px 6px' }} onClick={() => setEditingPw(p => ({ ...p, [`s-${s.id}`]: true }))}>変更</button>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        ))}
                        <button style={{ ...S.btnPrimary, marginTop: 12 }} onClick={() => {
                          const win = window.open('', '_blank');
                          const school = expandedSchool;
                          const rows = schoolClasses.map(cls =>
                            `<h3 style="color:#3c3489">${cls.grade}年${cls.class_name}（${cls.students.length}名）</h3>` +
                            `<table border="1" cellpadding="6" style="border-collapse:collapse;margin-bottom:16px">` +
                            `<tr><th>番号</th><th>パスワード</th></tr>` +
                            cls.students.map(s => `<tr><td>${s.number}番</td><td>${s.password_plain || '****'}</td></tr>`).join('') +
                            `</table>`
                          ).join('');
                          win.document.write(`<html><head><title>${school.school_name} 児童パスワード一覧</title><style>body{font-family:sans-serif;padding:20px}h2{color:#1a1a6e}@media print{button{display:none}}</style></head><body><h2>${school.school_name} 児童パスワード一覧</h2><p>学校コード：<strong>${school.school_code}</strong></p>${rows}<button onclick="window.print()">印刷する</button></body></html>`);
                          win.document.close();
                        }}>パスワード一覧を印刷</button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
            {schools.length === 0 && <div style={{ color: '#aaa', fontSize: 13 }}>登録された学校がありません</div>}
          </div>
        )}

        {section === 'info' && (
          <div style={S.card}>
            <div style={S.cardTitle}>登録情報確認</div>
            {registeredInfo ? (
              <>
                <div style={S.infoBox}>
                  <div style={S.infoRow}><span style={S.infoLabel}>学校名</span><span>{registeredInfo.school?.school_name}</span></div>
                  <div style={S.infoRow}><span style={S.infoLabel}>学校コード</span><span style={{ fontWeight: 700, color: '#3c3489', fontSize: 18, letterSpacing: 2 }}>{registeredInfo.school?.school_code}</span></div>
                  <div style={S.infoRow}><span style={S.infoLabel}>教師ログインID</span><span>{registeredInfo.teacher?.login_id}</span></div>
                  <div style={S.infoRow}><span style={S.infoLabel}>登録クラス数</span><span>{registeredInfo.class_count}クラス</span></div>
                  <div style={S.infoRow}><span style={S.infoLabel}>登録児童・生徒数</span><span>{registeredInfo.student_count}名</span></div>
                </div>
                <div style={S.warningBox}>※ 学校コード「<strong>{registeredInfo.school?.school_code}</strong>」は児童ログイン時に必要です。必ず学校に伝えてください。</div>
                <div style={S.sectionTitle}>クラス別パスワード一覧</div>
                {registeredInfo.classes?.map(cls => (
                  <div key={`${cls.grade}-${cls.class_name}`} style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#3c3489', marginBottom: 6 }}>{cls.grade}年{cls.class_name}（{cls.students.length}名）</div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                      {cls.students.map(s => <span key={s.number} style={{ ...S.pwTag, fontSize: 12, padding: '4px 10px' }}>{s.number}番: {s.password}</span>)}
                    </div>
                  </div>
                ))}
                <div style={{ marginTop: 16, display: 'flex', gap: 10 }}>
                  <button style={S.btnPrimary} onClick={() => window.print()}>印刷する</button>
                  <button style={S.btn} onClick={() => setSection('register')}>新しい学校を登録する</button>
                </div>
              </>
            ) : (
              <div style={{ color: '#aaa', fontSize: 13 }}>まだ登録した学校がありません。</div>
            )}
          </div>
        )}
        {section === 'account' && (
          <div style={S.card}>
            <div style={S.cardTitle}>管理者アカウント設定</div>
            <div style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>ログインIDまたはパスワードを変更できます。変更しない項目は空欄のままにしてください。</div>
            {credError && <div style={{ color: '#e53e3e', fontSize: 13, marginBottom: 10, padding: '8px 12px', background: '#fff5f5', borderRadius: 6 }}>{credError}</div>}
            {credMsg && <div style={{ color: '#38a169', fontSize: 13, marginBottom: 10, padding: '8px 12px', background: '#f0fff4', borderRadius: 6 }}>{credMsg}</div>}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 400 }}>
              <div>
                <label style={S.label}>新しいログインID（変更しない場合は空欄）</label>
                <input style={S.input} type="text" placeholder="新しいログインID" value={credForm.login_id} onChange={e => setCredForm({...credForm, login_id: e.target.value})} />
              </div>
              <div>
                <label style={S.label}>現在のパスワード <span style={{ color: '#e53e3e' }}>※必須</span></label>
                <input style={S.input} type="password" placeholder="現在のパスワード" value={credForm.current_password} onChange={e => setCredForm({...credForm, current_password: e.target.value})} />
              </div>
              <div>
                <label style={S.label}>新しいパスワード（変更しない場合は空欄）</label>
                <input style={S.input} type="password" placeholder="新しいパスワード（4文字以上）" value={credForm.new_password} onChange={e => setCredForm({...credForm, new_password: e.target.value})} />
              </div>
              <div>
                <label style={S.label}>新しいパスワード（確認）</label>
                <input style={S.input} type="password" placeholder="新しいパスワードを再入力" value={credForm.new_password2} onChange={e => setCredForm({...credForm, new_password2: e.target.value})} />
              </div>
              <button style={S.btnPrimary} onClick={updateCredentials}>変更する</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
